/**
 * AdminPage — sub-shell for /admin/* routes.
 * Top tabs (Overview / Users) below the regular AppShell header.
 */
import { useState } from 'react';
import { Reveal } from '@/components/Reveal';
import { SectionHeading } from '@/components/SectionHeading';
import { AdminOverview } from './AdminOverview';
import { AdminUsers } from './AdminUsers';

type Tab = 'overview' | 'users';

export function AdminPage(): JSX.Element {
  const [tab, setTab] = useState<Tab>('overview');

  return (
    <div className="space-y-8">
      <Reveal>
        <SectionHeading
          eyebrow="Admin · 后台"
          title={<>速通 · <span className="text-gradient-warm">运营仪表盘</span></>}
          subtitle="用户、配额、付费 — 一眼看完。"
          align="left"
        />
      </Reveal>

      <div className="inline-flex gap-1 rounded-full bg-ink-800/60 border border-honey-400/20 p-1 text-xs font-arcade tracking-widest">
        {(['overview', 'users'] as Tab[]).map((k) => (
          <button
            key={k}
            onClick={() => setTab(k)}
            className={`px-4 py-2 rounded-full transition-all ${
              tab === k ? 'bg-honey-400/20 text-honey-200 glow-cyan' : 'text-cream-400 hover:text-white'
            }`}
          >
            {k === 'overview' ? 'OVERVIEW' : 'USERS'}
          </button>
        ))}
      </div>

      {tab === 'overview' ? <AdminOverview /> : <AdminUsers />}
    </div>
  );
}
